'use strict'

import { Enum } from './enums'

const UserTypesEnum = new Enum({
  OFFICIAL: { value: 1, summaryCN: '正式用户', summaryEN: 'official' },
  EXPERIENCE: { value: 2, summaryCN: '体验用户', summaryEN: 'experience' }
  // ALL: { summaryCN: '所有用户', summaryEN: 'all' }
})

export { UserTypesEnum }



// WEBPACK FOOTER //
// ./src/utils/UserTypesEnum.js